import { connect } from "react-redux";
import React, { Component } from "react";
import { Button, Form, FormGroup, FormText, Label, Input } from "reactstrap";
import Table from "./util/tables/Table";
import TableHeading from "./util/tables/TableHeading";
import TableRow from "./util/tables/TableRow";
import TableHead from "./util/tables/TableHead";
import TableBody from "./util/tables/TableBody";
import TableCell from "./util/tables/TableCell";
import config from "../config/config";
import { computeUserConfigs } from "../helpers/utils";

const ITEMS_PER_PAGE = 20;

class BadgeGroupCsvJobPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      jobsData: [],
      currentPage: 1,
      totalPages: 1,
    };
  }

  componentDidMount() {
    this.getQrCodeJobData(1);
  }

  handleUploadFileChange = (event) => {
    this.setState({ file: event.target.files[0] });
  };

  handleGenerateFormSubmit = async (event) => {
    event.preventDefault();
    if (!this.props.allowGenerateQrCode) {
      alert(
        "You are not allowed to generate QR codes. Contact an administrator."
      );
      return;
    }

    if (!/\.csv$/.test(this.state.file.name)) {
      alert("Your file extension is not .csv");
      window.location.reload();
      return;
    }

    try {
      let profile = JSON.parse(window.localStorage.getItem("profile"));
      let requesterName = profile.name;

      const response = await fetch(
        `${config.apiGatewayProcotol}://${config.apiGatewayHostname}${config.apiGatewayContext}/ebadge-admin/v1/qr-code/upload-url?` +
        new URLSearchParams({
          requesterName: requesterName
        }),
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${this.props.jwt}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to get upload URL");
      }
      const data = await response.json();

      const file = this.state.file;
      if (file && data.uploadUrl) {
        const formData = new FormData();
        formData.append("file", file);

        const uploadResponse = await fetch(data.uploadUrl, {
          method: "PUT",
          headers: {
            "Content-Type": "text/csv",
            "x-amz-meta-requester_name": requesterName
          },
          body: formData,
        });

        if (!uploadResponse.ok) {
          throw new Error("File upload failed");
        }
      }
      alert(
        "Your request has been submitted. Please wait a few minutes for results to show up."
      );
    } catch (error) {
      console.error("Error: ", error);
      alert(
        "There was an error while submitting your request. See console for more details."
      );
    }

    window.location.reload();
  };

  handleDownloadZip = async (projectCode, year, s3ObjectKey) => {
    try {
      const attachment = await fetch(
        `${config.apiGatewayProcotol}://${config.apiGatewayHostname}${config.apiGatewayContext}/ebadge-admin/v1/qr-code/download`,
        {
          method: "POST",
          body: JSON.stringify({
            objectKey: s3ObjectKey,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.props.jwt}`,
          },
        }
      );

      const fileName = `${projectCode}-${year}_${new Date().getTime()}.zip`;

      const attachmentBlob = await attachment.blob();
      // ie11
      if (navigator.msSaveBlob) {
        return navigator.msSaveBlob(attachmentBlob, fileName);
      } else {
        const url = window.URL.createObjectURL(attachmentBlob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      }
    } catch (error) {
      console.error(error);
    }
  };

  getQrCodeJobData = async (pageToGet) => {
    try {
      const response = await fetch(
        `${config.apiGatewayProcotol}://${config.apiGatewayHostname}${config.apiGatewayContext}/ebadge-admin/v1/qr-code/jobs?` +
          new URLSearchParams({
            page: pageToGet,
            pageItem: ITEMS_PER_PAGE,
          }),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.props.jwt}`,
          },
        }
      );
      const data = await response.json();
      this.setState({
        currentPage: pageToGet,
        jobsData: data.qrCodeDtoList,
        totalPages: Math.ceil(data.totalResult / ITEMS_PER_PAGE),
      });
    } catch (error) {
      console.error(error);
    }
  };

  handleGoToNextPage = () => {
    this.getQrCodeJobData(this.state.currentPage + 1);
  };

  handleGoToPrevPage = () => {
    this.getQrCodeJobData(this.state.currentPage - 1);
  };

  render() {
    return (
      <div className="col-lg">
        {this.props.allowGenerateQrCode && (
          <div className="row">
            <Form onSubmit={this.handleGenerateFormSubmit}>
              <FormGroup>
                <Label for="uploadFile">Upload CSV to generate QR Codes</Label>
                <Input
                  type="file"
                  name="file"
                  id="uploadFile"
                  accept=".csv"
                  onChange={this.handleUploadFileChange}
                />
                <FormText color="muted">Upload QR Code Generation CSV</FormText>
              </FormGroup>
              <Button
                disabled={
                  this.state.file == null || !this.props.allowGenerateQrCode
                }
              >
                Generate
              </Button>
            </Form>
          </div>
        )}
        <div className="row mt-5">
          <Table>
            <TableHeading>
              <TableRow>
                <TableHead>Project Code</TableHead>
                <TableHead>Year</TableHead>
                <TableHead>Start Date</TableHead>
                <TableHead>End Date</TableHead>
                <TableHead>Job ID</TableHead>
                <TableHead>Requester Name</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>QR Code</TableHead>
              </TableRow>
            </TableHeading>
            <TableBody>
              {this.state.jobsData &&
                this.state.jobsData.map((fair, index) => (
                  <TableRow key={`qrcode-table-row${index}`}>
                    <TableCell>{fair.projectCode}</TableCell>
                    <TableCell>{fair.year}</TableCell>
                    <TableCell>{fair.startTime}</TableCell>
                    <TableCell>{fair.endTime}</TableCell>
                    <TableCell>{fair.jobId}</TableCell>
                    <TableCell>{fair.requesterName}</TableCell>
                    <TableCell>{fair.status}</TableCell>
                    <TableCell>
                      {fair.status && fair.status == "SUCCESS" && (
                        <Button
                          color="primary"
                          onClick={() =>
                            this.handleDownloadZip(
                              fair.projectCode,
                              fair.year,
                              fair.s3ObjectKey
                            )
                          }
                        >
                          Download
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              {(!this.state.jobsData || this.state.jobsData.length == 0) &&
                "Loading..."}
            </TableBody>
          </Table>
          <div className="row mt-5">
            <Button
              disabled={this.state.currentPage == 1 || this.state.totalPages == 0}
              onClick={this.handleGoToPrevPage}
            >
              Previous Page
            </Button>
            <Button
              disabled={
                this.state.totalPages == this.state.currentPage ||
                this.state.totalPages == 0
              }
              onClick={this.handleGoToNextPage}
            >
              Next Page
            </Button>
            <div className="ml-5">Page {this.state.currentPage} out of {this.state.totalPages}</div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let roleConfig = computeUserConfigs(state.loginUser.roleIds);
  return {
    jwt: state.loginUser.jwt,
    allowGenerateQrCode: roleConfig.allowGenerateQrCode,
  };
};

export default connect(mapStateToProps)(BadgeGroupCsvJobPage);



// WEBPACK FOOTER //
// ./src/components/BadgeGroupCsvJobPage.js